import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice'
import languageSlise from './slices/languageSlice'
import websiteSlice from './slices/websiteSlice'
import uiReducer from './slices/uiSlice';

export const store = configureStore({
    reducer: {
        auth: authSlice,
        language: languageSlise,
        website: websiteSlice,
        ui: uiReducer
    }
});